import { Component } from "@angular/core";

@Component({
    selector: 'page-list',
    templateUrl: './page-list.component.html'
})
export class PageListComponent {

}